import { io, type Socket } from 'socket.io-client';
import type { ClientToServerEvents, ServerToClientEvents } from '@ember/shared';

/**
 * Client Socket.IO singleton, type-safe via @ember/shared.
 *
 * - URL : vide -> meme origin que la page (le proxy Vite redirige /socket.io
 *   vers http://localhost:4000 en dev, en prod c'est Caddy qui le fait).
 * - autoConnect: false : on connecte explicitement quand on en a besoin,
 *   evite d'ouvrir une WS quand le user est juste sur la HomePage.
 * - reconnection : Socket.IO retente seul la connexion en cas de coupure
 *   (cas mobile classique : changement reseau wifi/4G, screen lock, switch app).
 *   On expose les events `connect`, `disconnect`, `connect_error`, `reconnect_attempt`
 *   pour que les hooks puissent afficher une banniere "Reconnexion en cours...".
 */

export type AppSocket = Socket<ServerToClientEvents, ClientToServerEvents>;

let instance: AppSocket | null = null;

export function getSocket(): AppSocket {
  if (!instance) {
    instance = io('', {
      autoConnect: false,
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      // Timeout d'une tentative avant de considerer l'attempt comme failed.
      timeout: 10000,
    });
  }
  return instance;
}

/**
 * Reset hard du socket (test / debug). A eviter en runtime normal.
 */
export function resetSocket(): void {
  if (instance) {
    instance.disconnect();
    instance.removeAllListeners();
    instance = null;
  }
}
